import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';

export default function HotComicsSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">
                热门推荐
              </h2>
              <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                每日更新
              </span>
            </div>
            <p className="text-sm text-foreground-500">精选热门漫画，畅快追漫不停歇</p>
          </div>
          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-background-200 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-background-200 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="flex-shrink-0 w-[200px] md:w-[220px] group"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4] bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 叮当漫画网`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2 left-2 flex flex-wrap gap-1">
                  {comic.tags.map((tag) => (
                    <span key={tag} className="px-2 py-0.5 bg-primary-500 text-background-50 text-[10px] font-medium rounded-full whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="absolute bottom-2 right-2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <span className="text-sm md:text-base font-bold">{comic.rating}</span>
                </div>
              </div>
              <p className="text-xs text-foreground-500 mb-1">{comic.category} · {comic.chapters}话</p>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap overflow-hidden text-ellipsis">
                {comic.title}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}